import React, { useState, useEffect } from "react";
import ReactDOM from "react-dom";
import { Button } from "Components/atoms/Button";
import {
  FieldSearchContentMobile,
  FieldSearchHeaderMobile,
  FieldSearchMobile,
  GuestSelectorModalContent,
  GuestSelectorModalFooter,
  GuestSelectorModalHeader,
  IconContent,
  InfoContent,
  ModalBackdrop,
} from "./styles";
import { ReactComponent as CalendarBackSvg } from "assets/svgs/calendar-back.svg";
import { FaArrowLeft } from "react-icons/fa";
import { GuestSelectorModalProps } from "./types";
import { GuestSelectorDropdownMobile } from "../GuestSelectorDropdown/Mobile";
import { ReactComponent as AdultsSvg } from "assets/svgs/adults.svg";
import { ReactComponent as BabiesSvg } from "assets/svgs/babies.svg";
import { ReactComponent as ChildrenSvg } from "assets/svgs/children.svg";
import { Typography } from "Components/atoms/Typography";
import { theme } from "styles/theme";
import { useGeneralContext } from "shared/contexts/GeneralContext";
import { useSearchContext } from "shared/contexts/SearchContext";

export const GuestSelectorModal: React.FC<GuestSelectorModalProps> = ({
  isVisibleModal,
  onClose,
}) => {
  const { isHeaderVisible } = useGeneralContext();
  const { searchState, setAdults, setChildren, setBabies } = useSearchContext();

  useEffect(() => {
    if (isVisibleModal) {
      document.body.style.overflow = "hidden";
      document.body.style.height = "100vh";
    } else {
      document.body.style.overflow = "";
      document.body.style.height = "";
    }

    return () => {
      document.body.style.overflow = "";
      document.body.style.height = "";
    };
  }, [isVisibleModal]);

  if (!isVisibleModal) return null;

  const handleIsVisible = () => {
    onClose();
  };

  const modalContent = (
    <ModalBackdrop onClick={(e) => e.stopPropagation()}>
      <FieldSearchContentMobile
        isVisible={isVisibleModal}
        isHeaderVisible={isHeaderVisible}
      >
        <FieldSearchHeaderMobile isVisible={isVisibleModal}>
          <Button
            onClick={handleIsVisible}
            icon={<FaArrowLeft />}
            color="white"
            size="ghost"
          />
          <FieldSearchMobile isVisible={isVisibleModal}>
            <GuestSelectorModalHeader>
              <IconContent>
                <AdultsSvg style={{ fill: "#FFFFFF" }} />
              </IconContent>
              <InfoContent>
                <Typography color={theme.colors.white} variant="h2">
                  Passageiros
                </Typography>
                <Typography color={theme.colors.white} variant="label">
                  Selecione a quantidade de passageiros
                </Typography>
              </InfoContent>
            </GuestSelectorModalHeader>
            <GuestSelectorModalContent>
              <GuestSelectorDropdownMobile
                adults={searchState.adults}
                children={searchState.children}
                babies={searchState.babies}
                onAdultsChange={setAdults}
                onChildrenChange={setChildren}
                onBabiesChange={setBabies}
                icons={{
                  adults: <AdultsSvg />,
                  children: <ChildrenSvg />,
                  babies: <BabiesSvg />,
                }}
              />
            </GuestSelectorModalContent>
          </FieldSearchMobile>
        </FieldSearchHeaderMobile>

        <GuestSelectorModalFooter>
          <Button
            label="Confirmar"
            backgroundColor="yellow"
            color="black"
            size="extra-large"
            uppercase
            rounded
            onClick={() => {
              onClose();
            }}
            width={"70%"}
            height={50}
          />
        </GuestSelectorModalFooter>
      </FieldSearchContentMobile>
    </ModalBackdrop>
  );

  return ReactDOM.createPortal(modalContent, document.body);
};
